"use client";

import { createContext, FC, useMemo, useState } from "react";

interface ISearchContextData {
  offset: number;
  itemsPerPage: number;
  total: number;
}

export interface ISearchContext {
  searchData: ISearchContextData;
  setSearchData: (searchData: ISearchContextData) => void;
}

interface SearchProviderProps {
  initialSearchData: ISearchContextData;
  children?: React.ReactNode;
}

export const SearchContext = createContext<ISearchContext | null>(null);

export const SearchProvider: FC<SearchProviderProps> = ({ initialSearchData, children }) => {
  const [searchData, setSearchData] = useState<ISearchContextData>(initialSearchData);

  const value = useMemo(() => ({ searchData, setSearchData }), [searchData, setSearchData]);

  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
};
